import styled from "styled-components";

export const ExperienceContainer = styled.div`
  background-color: gray;
  width: 100%;
`;
